import requestAction from '../../utils/requestAction'

export const fetchPreorderDetail = (preorderDetailId: any) =>
  requestAction('PREORDER_DETAIL_DATA')(`preorderDetails/${preorderDetailId}`, 'GET')


export const fetchPreorderDetails = (preorderId: string, clientId?: string, params?: string) =>   
  requestAction('PREORDER_DETAIL_LIST')(`preorders/detail?preorderId=${preorderId}${clientId ? '&clientId='+clientId: ''}${params ? '&'+params.replace('?', '') : ''}`, 'GET')
